import React, { useState } from 'react';
import CloseIcon from '../../../../assets/icons/close.svg';
import { AuthenticatedPUTRequest, hasNull } from '../../../../utils';
import { isEmptyObject } from '../../../../utils';

const EditPersonalInfoModal = (props) => {
    const { id, teacher, onError, onClose } = props;
    const [personalInformation, setPersonalInformation] = useState({
        name: teacher.name,
        father_name: teacher.father_name,
        date_of_birth: teacher.date_of_birth,
        cnic: teacher.cnic,
        primary_phone_number: teacher.primary_phone_number,
        secondary_phone_number: teacher.secondary_phone_number,
    });
    const [loading, setLoading] = useState(false);
    const updateTeacher = async (values) => {
        setLoading(true);
        try {
            const { success } = await AuthenticatedPUTRequest(`teachers/${id}`, {
                teacher: values,
            });
            setLoading(false);
            onClose();
            if (!success) {
                onError('براہ کرم دوبارہ کوشش کریں۔');
            } else {
                window.location.reload();
            }
        } catch (error) {
            setLoading(false);
            onError('براہ کرم دوبارہ کوشش کریں۔');
        }
    };
    const onSubmit = () => {
        const isSuccess = hasNull(personalInformation);
        if (isSuccess) {
            onError('مہرنانی، مکمل معلومات درج کریں');
        } else {
            var updatedInformation = {};
            for (let key in personalInformation) {
                if (personalInformation[key] !== teacher[key]) {
                    updatedInformation[key] = personalInformation[key];
                }
            }
            if (!isEmptyObject(updatedInformation)) {
                updateTeacher(updatedInformation);
            } else {
                onClose();
            }
        }
    };

    return (
        <div
            className='flex column justifyCenter alignCenter'
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                zIndex: 1000,
                background: 'rgba(0,0,0,0.7)',
            }}
        >
            <div
                style={{
                    background: '#ffffff',
                    height: 425,
                    maxHeight: 425,
                    width: 980,
                    borderRadius: 8,
                }}
            >
                <div className='h-100 w-100' style={{ overflow: 'auto', position: 'relative' }}>
                    <div
                        className='flex justifyBetween alignCenter w-100'
                        style={{
                            borderBottom: '1px solid #E0E0E0',
                            padding: '20px 16px 8px',
                            height: 72,
                        }}
                    >
                        <h2 className='flex alignCenter w-100' style={{ color: '#009688' }}>
                            ذاتی معلومات کے ریکارڈ میں ترمیم کریں
                        </h2>

                        <img
                            src={CloseIcon}
                            alt='close_icon'
                            height={32}
                            width={32}
                            onClick={props.onClose}
                            style={{ cursor: 'pointer' }}
                        />
                    </div>

                    <div
                        className='flex column justifyCenter alignCenter urdu'
                        style={{ padding: 20, height: 'calc(100% - 156px)' }}
                    >
                        <div className='flex justifyBetween alignCenter w-100'>
                            <div className='form-container'>
                                <label htmlFor='name'>
                                    نام
                                    <span className='required'>*</span>
                                </label>
                                <input
                                    type='text'
                                    name='name'
                                    value={personalInformation.name}
                                    autoFocus='on'
                                    onKeyUp={(event) => {
                                        if (event.keyCode === 13) {
                                            setPersonalInformation({
                                                ...personalInformation,
                                                name: event.target.value,
                                            });
                                            onSubmit();
                                        }
                                    }}
                                    onChange={(event) => {
                                        if (event.target.value.length > 0) {
                                            setPersonalInformation({
                                                ...personalInformation,
                                                name: event.target.value,
                                            });
                                        } else {
                                            setPersonalInformation({
                                                ...personalInformation,
                                                name: '',
                                            });
                                        }
                                    }}
                                />
                            </div>
                            <div className='form-container'>
                                <label htmlFor='father_name'>
                                    والدیت
                                    <span className='required'>*</span>
                                </label>
                                <input
                                    type='text'
                                    name='father_name'
                                    value={personalInformation.father_name}
                                    onKeyUp={(event) => {
                                        if (event.keyCode === 13) {
                                            setPersonalInformation({
                                                ...personalInformation,
                                                father_name: event.target.value,
                                            });
                                            onSubmit();
                                        }
                                    }}
                                    onChange={(event) => {
                                        if (event.target.value.length > 0) {
                                            setPersonalInformation({
                                                ...personalInformation,
                                                father_name: event.target.value,
                                            });
                                        } else {
                                            setPersonalInformation({
                                                ...personalInformation,
                                                father_name: 0,
                                            });
                                        }
                                    }}
                                />
                            </div>
                            <div className='form-container'>
                                <label htmlFor='dateOfBirth'>
                                    تاریخ پیدائش
                                    <span className='required'>*</span>
                                </label>
                                <input
                                    type='date'
                                    name='dateOfBirth'
                                    s
                                    style={{ fontFamily: 'CircularStd' }}
                                    value={personalInformation.date_of_birth}
                                    onKeyUp={(event) => {
                                        if (event.keyCode === 13) {
                                            setPersonalInformation({
                                                ...personalInformation,
                                                date_of_birth: event.target.value,
                                            });
                                            onSubmit();
                                        }
                                    }}
                                    onChange={(event) => {
                                        if (event.target.value.length > 0) {
                                            setPersonalInformation({
                                                ...personalInformation,
                                                date_of_birth: event.target.value,
                                            });
                                        } else {
                                            setPersonalInformation({
                                                ...personalInformation,
                                                date_of_birth: '',
                                            });
                                        }
                                    }}
                                />
                            </div>
                        </div>
                        <div className='flex justifyBetween alignCenter w-100'>
                            <div className='form-container'>
                                <label htmlFor='cnic'>
                                    شناختی کارڈ نمبر
                                    <span className='required'>*</span>
                                </label>
                                <input
                                    type='text'
                                    name='cnic'
                                    value={personalInformation.cnic}
                                    s
                                    style={{ fontFamily: 'CircularStd' }}
                                    maxLength={13}
                                    onKeyUp={(event) => {
                                        if (event.keyCode === 13) {
                                            setPersonalInformation({
                                                ...personalInformation,
                                                cnic: event.target.value,
                                            });
                                            onSubmit();
                                        }
                                    }}
                                    onChange={(event) => {
                                        if (event.target.value.length > 0) {
                                            setPersonalInformation({
                                                ...personalInformation,
                                                cnic: event.target.value,
                                            });
                                        } else {
                                            setPersonalInformation({
                                                ...personalInformation,
                                                cnic: '',
                                            });
                                        }
                                    }}
                                />
                            </div>
                            <div className='form-container'>
                                <label htmlFor='primary_phone_number'>
                                    موبائل نمبر/ واٹس ایپ نمبر
                                    <span className='required'>*</span>
                                </label>
                                <input
                                    type='text'
                                    name='primary_phone_number'
                                    s
                                    style={{ fontFamily: 'CircularStd' }}
                                    maxLength={11}
                                    value={personalInformation.primary_phone_number}
                                    onKeyUp={(event) => {
                                        if (event.keyCode === 13) {
                                            setPersonalInformation({
                                                ...personalInformation,
                                                primary_phone_number: event.target.value,
                                            });
                                            onSubmit();
                                        }
                                    }}
                                    onChange={(event) => {
                                        if (event.target.value.length > 0) {
                                            setPersonalInformation({
                                                ...personalInformation,
                                                primary_phone_number: event.target.value,
                                            });
                                        } else {
                                            setPersonalInformation({
                                                ...personalInformation,
                                                primary_phone_number: '',
                                            });
                                        }
                                    }}
                                />
                            </div>
                            <div className='form-container'>
                                <label htmlFor='secondary_phone_number'>
                                    متبادل نمبر
                                    <span className='required'>*</span>
                                </label>
                                <input
                                    type='text'
                                    name='secondary_phone_number'
                                    value={personalInformation.secondary_phone_number}
                                    style={{ fontFamily: 'CircularStd' }}
                                    maxLength={13}
                                    onKeyUp={(event) => {
                                        if (event.keyCode === 13) {
                                            setPersonalInformation({
                                                ...personalInformation,
                                                secondary_phone_number: event.target.value,
                                            });
                                            onSubmit();
                                        }
                                    }}
                                    onChange={(event) => {
                                        if (event.target.value.length > 0) {
                                            setPersonalInformation({
                                                ...personalInformation,
                                                secondary_phone_number: event.target.value,
                                            });
                                        } else {
                                            setPersonalInformation({
                                                ...personalInformation,
                                                secondary_phone_number: '',
                                            });
                                        }
                                    }}
                                />
                            </div>
                        </div>
                    </div>

                    <div
                        className='flex justifyEnd alignCenter w-100'
                        style={{ height: 64, paddingLeft: 16 }}
                    >
                        <div className='flex justifyBetween alignCenter'>
                            <div
                                className='flex justifyEnd alignCenter register_button'
                                style={{ margin: '0 8px' }}
                                onClick={() => onSubmit()}
                            >
                                {loading ? (
                                    <div className='custom_loader' />
                                ) : (
                                    <h3>{`محفوظ کریں`}</h3>
                                )}
                            </div>
                            <div
                                className='flex justifyEnd alignCenter delete_button'
                                style={{ margin: '0 8px' }}
                                onClick={props.onClose}
                            >
                                <h3>{`منسوخ کریں`}</h3>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EditPersonalInfoModal;
